import { ReactChild } from 'react'
import { Alert, Text } from '@backyard-ui/core'

import { DiscountTicket } from './components'

import * as S from './styled'

 const COUPON_PHRASE_DICTIONARY = {
  available: '<b>Você tem cupons disponíveis.</b> Siga com a compra e aplique seu cupom na etapa de pagamento!',
  unavailable: '<b>Tem cupom disponível?</b> Siga com a compra e aplique seu cupom na etapa de pagamento!'
 }

type Props = {
  hasAvailable: boolean
  noMargin: boolean
}

const CouponAlertMessage = ({ hasAvailable, noMargin }: Props) => {
  const textContent = hasAvailable ? COUPON_PHRASE_DICTIONARY.available : COUPON_PHRASE_DICTIONARY.unavailable

  return (
    <S.AlertWrapper noMargin={noMargin}>
      <Alert.Root variant="neutral">
        <Alert.Icon children={<DiscountTicket />} />
        <Alert.Description>
          <Text size="md" dangerouslySetInnerHTML={{__html: textContent}}>{}</Text>
        </Alert.Description>
      </Alert.Root>
    </S.AlertWrapper>
  )
}

export default CouponAlertMessage
